import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import type { Company, CreateCompany } from '@recruitee/company-types';
import { HttpApiService } from '@recruitee/http';

@Injectable({ providedIn: 'root' })
export class CompanyHttpService {
  constructor(protected httpApi: HttpApiService) {}

  public update(body: Partial<Company>): Observable<Company> {
    return this.httpApi.patch(`/company`, null, {
      company: body,
    });
  }

  public create(body: CreateCompany, skipCompany: boolean = false): Observable<Company> {
    const { fillWithSampleData, ...company } = body;
    return this.httpApi.post(
      `/companies`,
      null,
      {
        company,
        fillWithSampleData,
      },
      { skipCompany },
    );
  }

  public leave({ id }: { id: number }): Observable<Company> {
    return this.httpApi.patch(`/companies/${id}/leave`);
  }
}
